import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {SubscriptionItem} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<SubscriptionItem, 'id'>,
    handleSubmit: (values: SubscriptionItem) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: SubscriptionItem) => {
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };

    let initialValues = {} as SubscriptionItem;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
